import { Component, input, OnInit } from '@angular/core';
import { PainAssessment } from 'src/app/calvin-emr-shared/models/assessments/pain.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { BooleanToYesNoPipe } from 'src/app/shared/utils/boolean-to-yes-no.pipe';


@Component({
  selector: 'app-pain-assessment-info',
  templateUrl: './pain-assessment-info.component.html',
  styleUrls: ['./pain-assessment-info.component.scss'],
  standalone: true,
  imports: [
    AssessmentRowComponent,
    BooleanToYesNoPipe,
  ],
})
export class PainAssessmentInfoComponent
  extends AssessmentInfoComponent<PainAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }
}
